export default "<span id=\"emojis\" ng-click=\"helper.preventClick($event)\"></span>";